<template>
<div class="container">

<div class="row center empty" v-show="list.length==0">
	<i class="fa fa-heart-o"></i>
	<p>暂无收藏</p>
</div>

<div class="row edit" v-if="list.length>0">
	<div class="col-8"></div>
	<div class="col-2"><mt-button size="small" class="btn" @click="edit">{{status==1?"编辑":"完成"}}</mt-button></div>
</div>

<div class="row item" v-for="(v,i) in list" @click="select(v,i)">
	<div class="col-1 check" v-show="status==2">
		<i class="fa fa-check-circle red" v-show="v.check==1"></i>
		<i class="fa fa-circle-o gray" v-show="v.check==0"></i>
	</div>
	<div class="col-3">
		<img :src="picurl+v.big_pic" :alt="v.name">
	</div>
	<div :class="{'col-6':status==2,'col-7':status==1}">
		<div class="row">
			<h4>{{v.name}} </h4>
		</div>
		<div class="row gray pd">
			<span v-if="v.attrs>0">规格：{{v.attr_value}}</span>
		</div>
		<div class="row pd">
			<span class="red">¥<span class="price">{{v.price/100}}</span></span>
			<span class="gray oprice">¥{{v.oprice/100}}</span>
		</div>
	</div>
</div>

<div class="row pdd" v-show="status==2&&delarr.length>0">
	<mt-button size="large" type="danger" @click="del">取消收藏</mt-button>
</div>

</div>
</template>


<style scoped>
.container{background: rgb(251,251,251);padding-bottom: 3rem;}
.pd{padding:0 .3rem;}
.pdd{padding:1rem;}
.item{padding:.3rem 3%;border-bottom: 1px solid #eee;background: white;}
.item img{width:90%;margin:5%;}
.item h4{height:3.6rem;font-weight:500; }
.price{font-size: 1.3rem;}	
.oprice{text-decoration:line-through;}
.check{height:7.3rem;line-height: 7.3rem;text-align:center;font-size:1.3rem;}

.edit{padding:0 .5rem;text-align: right;background: white;border-bottom: 1px solid #eee;}
.btn{border:0;background: white;color: #aaa;font-size:1.1rem;box-shadow:0 0 0 white;}
</style>

<script>

export default {
	data:function(){
		return {
          picurl:picurl,
          list:"",
          status:1,
          weitdel:{},
		}
	},
	created:function(){
		this.$emit("setTitle","我的收藏");
		this.init();
	},
	computed:{
		delarr:function(){
          return this.check();
		}
	},
	methods:{
		init:function(){
			var _this=this;
			fun.post(mydata.apiuser+"mylike",{},function(d){
				console.log(d);
				if(d.status==1){
					_this.list=d.info;
				}else{
					_this.$toast(d.info);
				}
			})
		},
		edit:function(){
          this.status=this.status==1?2:1;
		},
		select:function(v,i){
			if(this.status==1){
	            this.$router.push("/mall/detail/ucode/"+v.gucode);
				return;
			}
			if(v.check==1){
				this.weitdel[i]=v.check=0;
			}else{
                this.weitdel[i]=v.check=1;
			}
		},
		check:function(){
			var del=[];
			for(var i in this.list){
				if(this.list[i]['check']==1){
					del.push(this.list[i]['gucode']);
				}
			}
			return del;
		},
		dellist:function(){
			 var re=[];
	         for(var i in this.list){
	         	if(this.weitdel[i]!=1){
	         		re.push(this.list[i]);
	         	}
	         }
	        this.list=re;
		},
		del:function(){
			var data={
				gucode:this.delarr.join("-"),
			}
			var _this=this;
			fun.post(mydata.apiuser+"unlike",data,function(d){
				console.log(d);
				if(d.status==1){
					_this.dellist();
					_this.status=1;
				}else{
					_this.$toast(d.info);
				}
			})
		}
	}
}	
</script>


// WEBPACK FOOTER //
// src/components/user/like.vue